"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _reactDayPicker = _interopRequireWildcard(require("react-day-picker"));
var _date = _interopRequireDefault(require("@spothero/utils/date"));
var _DatePickerCalendarNavigation = _interopRequireDefault(require("./DatePickerCalendarNavigation"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DATE = new Date();
const DATE_FORMAT = 'MM/DD/YYYY';
class DatePickerCalendarWithRange extends _react.Component {
  static defaultProps = {
    numberOfMonths: 1,
    weekdayTitles: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    overrideInitialMonthWithSelected: true
  };
  constructor(props) {
    super(props);
    const {
      selectedStartDate,
      selectedEndDate
    } = props;
    this.state = {
      selectedStartDate: selectedStartDate ? _date.default.getAsDate(selectedStartDate) : null,
      selectedEndDate: selectedEndDate ? _date.default.getAsDate(selectedEndDate) : null
    };
  }
  _onDaySelected = (day, {
    selected,
    disabled
  }, evt) => {
    if (disabled) {
      return;
    }
    const {
      onChange
    } = this.props;
    const {
      to: selectedStartDate,
      from: selectedEndDate
    } = this._updateDateRange(day);
    this.setState({
      selectedStartDate,
      selectedEndDate
    });
    if (onChange) {
      onChange({
        selectedStartDate: selectedStartDate ? (0, _dayjs.default)(selectedStartDate).format(DATE_FORMAT) : null,
        selectedEndDate: selectedEndDate ? (0, _dayjs.default)(selectedEndDate).format(DATE_FORMAT) : null
      });
    }
  };
  _updateDateRange = newDate => {
    const {
      adjustStartOrEnd
    } = this.props;
    const {
      selectedStartDate: prevSelectedStartDate,
      selectedEndDate: prevSelectedEndDate
    } = this.state;
    let newStartDate;
    let newEndDate;
    if (!prevSelectedStartDate || !prevSelectedEndDate) {
      // if both start and end dates aren't populated, use the default logic
      const {
        from,
        to
      } = _reactDayPicker.DateUtils.addDayToRange(newDate, {
        from: prevSelectedStartDate,
        to: prevSelectedEndDate
      });
      newStartDate = from;
      newEndDate = to;
    } else if (adjustStartOrEnd === 'start') {
      // if start input is focused, update start date and clear end date
      newStartDate = newDate;
      newEndDate = null;
    } else if (adjustStartOrEnd === 'end' && !_reactDayPicker.DateUtils.isDayBefore(newDate, prevSelectedStartDate)) {
      // if end input is focused and newDate >= prevSelectedStartDate, update end date
      newStartDate = prevSelectedStartDate;
      newEndDate = newDate;
    } else if (adjustStartOrEnd === 'end' && _reactDayPicker.DateUtils.isDayBefore(newDate, prevSelectedStartDate)) {
      // if end input is focused and newDate < prevSelectedStartDate, update start date and clear end date
      newStartDate = newDate;
      newEndDate = null;
    }
    return {
      to: newStartDate,
      from: newEndDate
    };
  };
  _renderDayMarkup = day => {
    const m = (0, _dayjs.default)(day);
    const date = `${m.format('MM')}/${m.format('DD')}/${m.format('YYYY')}`;
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "DatePicker-Day--wrapper"
    }, /*#__PURE__*/_react.default.createElement("span", {
      "data-date": date
    }, day.getDate()));
  };
  render() {
    const {
      className,
      numberOfMonths,
      weekdayTitles,
      disableBefore,
      disableAfter,
      overrideInitialMonthWithSelected
    } = this.props;
    const {
      selectedStartDate,
      selectedEndDate
    } = this.state;
    const classes = (0, _classnames.default)('DatePicker-calendar', 'DatePicker-calendar-with-range', className);
    let firstMonth = DATE;
    let fromMonth = DATE;
    let toMonth = null;
    if (disableBefore) {
      const beforeDate = _date.default.getAsDate(disableBefore);
      if (fromMonth) {
        if ((0, _dayjs.default)(beforeDate).isAfter(fromMonth)) {
          fromMonth = beforeDate;
        }
      } else {
        fromMonth = beforeDate;
      }
      firstMonth = fromMonth;
    }
    if (disableAfter) {
      toMonth = _date.default.getAsDate(disableAfter);
    }
    if (selectedStartDate && overrideInitialMonthWithSelected) {
      firstMonth = selectedStartDate;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, /*#__PURE__*/_react.default.createElement(_reactDayPicker.default, {
      selectedDays: [selectedStartDate, {
        from: selectedStartDate,
        to: selectedEndDate
      }],
      modifiers: {
        start: selectedStartDate,
        end: selectedEndDate,
        'start-without-end': day => _reactDayPicker.DateUtils.isSameDay(day, selectedStartDate) && !selectedEndDate
      },
      disabledDays: {
        before: fromMonth,
        ...(toMonth && {
          after: toMonth
        })
      },
      fromMonth: fromMonth,
      toMonth: toMonth,
      initialMonth: firstMonth,
      onDayClick: this._onDaySelected,
      numberOfMonths: numberOfMonths,
      renderDay: this._renderDayMarkup,
      weekdaysShort: weekdayTitles,
      navbarElement: /*#__PURE__*/_react.default.createElement(_DatePickerCalendarNavigation.default, null)
    }));
  }
}
exports.default = DatePickerCalendarWithRange;